import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { countShowPropertyOnPage } from 'src/constants';
import {
  getFilterLeavedSlide,
  getFilterParamDataCountMobileResult,
} from 'src/store/filter/filter-params/selectors';
import { Actions } from 'src/store/filter/filter-params/actions';

export const useStateListOfLayout = (length: number) => {
  const dispatch = useDispatch();
  const defaultCount = countShowPropertyOnPage;
  const [lengthOfList, setLengthOfList] = useState<number>(length);
  const [isShowLoadMoreBtn, setShowLoadMoreBtn] = useState<boolean>(true);
  const countShowedProperty = useSelector(getFilterParamDataCountMobileResult);
  const leavedReduxSlide = useSelector(getFilterLeavedSlide);

  useEffect(() => {
    if (length !== lengthOfList) {
      dispatch(Actions.setFilterMobileCount(defaultCount));
      setLengthOfList(length);
      setShowLoadMoreBtn(true);
    }
    if (countShowedProperty > lengthOfList) {
      setShowLoadMoreBtn(false);
    }
  }, [dispatch, defaultCount, length, lengthOfList, countShowedProperty]);

  const handleShowMore = useCallback(() => {
    if (countShowedProperty < lengthOfList) {
      dispatch(Actions.setFilterMobileCount(countShowedProperty + defaultCount));
    }
  }, [dispatch, defaultCount, countShowedProperty, lengthOfList]);

  return {
    isShowLoadMoreBtn,
    lengthOfList,
    countShowedProperty,
    handleShowMore,
    leavedSlide: leavedReduxSlide !== null ? leavedReduxSlide : 0,
  };
};
